export const RETRO_TABS = [
  { key: "dash", label: "My Dashboard" },
  { key: "team", label: "My Team" },
  { key: "learn", label: "Learnings" },
];

export const RETRO_MOCK = {
  cycle: {
    title: "Performance Retro",
    cycleLabel: "Q1 2026 cycle",
    status: "in review",
  },
  dashboard: {
    zone: {
      current: "Independent Solver",
      target: "System Builder",
      levels: [
        "Needs Structured Support",
        "Execution Driven",
        "Independent Solver",
        "System Builder",
        "Strategic Owner",
      ],
    },
    radar: {
      axes: [
        "Technical depth",
        "Delivery & ownership",
        "Cross-functional craft",
        "Mentorship",
        "Communication",
        "Strategic thinking",
        "Quality of work",
        "Complex developments",
      ],
      target: [8.0, 9.0, 8.0, 7.6, 8.0, 7.0, 8.4, 8.0],
      seriesByPeriod: {
        week: [
          { id: "w17", label: "Wk 17 · Apr 21–27", values: [8.0, 9.0, 7.6, 6.4, 7.2, 5.6, 7.8, 7.4] },
          { id: "w16", label: "Wk 16 · Apr 14–20", values: [7.8, 8.8, 7.2, 6.0, 7.0, 5.2, 7.6, 7.2] },
          { id: "w15", label: "Wk 15 · Apr 07–13", values: [7.6, 8.6, 7.4, 6.2, 6.8, 5.4, 7.4, 7.0] },
        ],
        month: [
          { id: "m04", label: "Apr 2026", values: [7.9, 8.9, 7.4, 6.2, 7.1, 5.4, 7.6, 7.2] },
          { id: "m03", label: "Mar 2026", values: [7.4, 8.4, 6.8, 5.6, 6.6, 5.0, 7.0, 6.6] },
        ],
        quarter: [
          { id: "q1-26", label: "Q1 2026", values: [7.0, 8.0, 6.6, 5.2, 6.2, 4.6, 6.6, 6.2] },
          { id: "q4-25", label: "Q4 2025", values: [6.4, 7.6, 6.0, 4.6, 5.6, 4.2, 6.2, 5.8] },
        ],
        year: [
          { id: "y26", label: "YTD 2026", values: [7.6, 8.6, 7.0, 5.8, 6.8, 5.2, 7.2, 6.8] },
          { id: "y25", label: "FY 2025", values: [6.0, 7.2, 5.6, 4.4, 5.4, 4.0, 5.8, 5.4] },
        ],
      },
    },
    trend: [
      { id: "w10", label: "W10", sub: "Mar 03", score: 6.4 },
      { id: "w11", label: "W11", sub: "Mar 10", score: 6.6 },
      { id: "w12", label: "W12", sub: "Mar 17", score: 6.5 },
      { id: "w13", label: "W13", sub: "Mar 24", score: 6.8 },
      { id: "w14", label: "W14", sub: "Mar 31", score: 6.9 },
      { id: "w15", label: "W15", sub: "Apr 07", score: 7.0 },
      { id: "w16", label: "W16", sub: "Apr 14", score: 7.2 },
      { id: "w17", label: "W17", sub: "Apr 21", score: 7.4 },
    ],
    strengths: [
      { title: "Strong ownership", meta: "Top 10%" },
      { title: "Good collaboration", meta: "+5 endorsements" },
      { title: "Improved communication", meta: "+0.6 vs Q4" },
      { title: "Reliable delivery", meta: "8 of 8 sprints" },
    ],
    growthAreas: [
      { title: "Timeliness consistency", meta: "3 sprint slips" },
      { title: "Debugging approach", meta: "2 retro mentions" },
      { title: "Documentation clarity", meta: "peer signal" },
    ],
    playbook: [
      { id: "p1", seq: "01", title: "Handle one cross-module problem independently", tag: "System thinking", done: true, eta: "Apr 14" },
      { id: "p2", seq: "02", title: "Document repeatable solutions in team wiki", tag: "Documentation", done: false, eta: "May 02" },
      { id: "p3", seq: "03", title: "Mentor one junior resource through a sprint", tag: "Mentorship", done: false, eta: "May 09" },
      { id: "p4", seq: "04", title: "Lead a cross-team RFC review", tag: "Strategic thinking", done: false, eta: "May 20" },
    ],
    goals: [
      { code: "G-01", title: "Ship eKYC v2 to staging", progress: 100, status: "done" },
      { code: "G-02", title: "Reduce p99 order-routing latency to <180ms", progress: 88, status: "on_track" },
      { code: "G-03", title: "Mentor two engineers through architecture review", progress: 65, status: "in_flight" },
      { code: "G-04", title: "Publish internal trading deep-dive", progress: 22, status: "at_risk" },
      { code: "G-05", title: "Run quarterly architecture clinic", progress: 100, status: "done" },
    ],
    competencies: [
      { key: "Technical depth", value: 5.6 },
      { key: "Quality of work", value: 7.8 },
      { key: "Complex developments", value: 7.4 },
    ],
    reflections: [
      { key: "went_well", title: "What went well", body: "Shipped eKYC rewrite two weeks ahead of plan." },
      { key: "do_better", title: "What can be done better", body: "Should have delegated NSCCL data mapping earlier." },
      { key: "improve", title: "What I am going to improve", body: "Use mentorship as leverage, not overhead." },
      { key: "repeat", title: "Where I'm going repeat", body: "Co-lead strategic cross-product roadmap in Q2." },
    ],
  },
  team: {
    rollup: [
      { key: "Team avg", value: "3.6/5", meta: "Across 6 reports" },
      { key: "Submissions", value: "4/6", meta: "4 in · 2 pending" },
      { key: "Goal attainment", value: "81%", meta: "Median across team" },
      { key: "Flags raised", value: "2 open", meta: "Career-growth signals" },
      { key: "Feedback pending", value: "4 / 10", meta: "Pending for May 10 and 18" },
    ],
    members: [
      { id: "u1", name: "Rohit Menon", role: "SDE 3 · Engineering", current: "Independent Solver", target: "System Builder", score: 8.4, delta: 0.3, goalPct: 92, tenure: "3y 4m", status: "Submitted" },
      { id: "u2", name: "Meera Iyer", role: "SDE 2 · Product Eng", current: "Confident Contributor", target: "Independent Solver", score: 7.0, delta: 0.2, goalPct: 78, tenure: "1y 8m", status: "Submitted" },
      { id: "u3", name: "Karan Shetty", role: "Staff Eng · Settlement", current: "System Builder", target: "Architect", score: 9.4, delta: 0.1, goalPct: 58, tenure: "5y 1m", status: "Draft" },
      { id: "u4", name: "Nisha Kapoor", role: "SDE 2 · Platform", current: "Confident Contributor", target: "Independent Solver", score: 7.6, delta: 0.2, goalPct: 88, tenure: "2y 0m", status: "Not started" },
      { id: "u5", name: "Arjun Das", role: "SDE 1 · Mobile", current: "Needs Structured Support", target: "Confident Contributor", score: 6.8, delta: 0.4, goalPct: 84, tenure: "11m", status: "Submitted" },
      { id: "u6", name: "Priya Shah", role: "Tech Lead · Trading", current: "Independent Solver", target: "System Builder", score: 8.0, delta: -0.1, goalPct: 46, tenure: "4y 6m", status: "Overdue" },
    ],
    memberDetails: {
      u1: {
        lastReview: "Apr 21",
        currentStage: "Independent Solver",
        targetStage: "System Builder",
        stageProgress: 72,
        parameterScores: [
          { name: "Technical depth", curr: 4.2, prev: 3.9, hist: [3.6, 3.8, 3.9, 4.0, 4.2] },
          { name: "System thinking", curr: 4.0, prev: 3.7, hist: [3.4, 3.5, 3.7, 3.9, 4.0] },
          { name: "Communication", curr: 3.9, prev: 3.6, hist: [3.1, 3.3, 3.5, 3.7, 3.9] },
        ],
        cadenceGoals: {
          weekly: [
            { title: "Land settlement RFC v2 review", kpi: "2 reviewers", progress: 60, approved: false },
            { title: "Pair with Arjun on iOS perf bug", kpi: "1 session", progress: 100, approved: true },
          ],
          monthly: [
            { title: "Run sprint planning solo", kpi: "3 cycles", progress: 60, approved: false },
          ],
          quarterly: [
            { title: "Mentor SDE-1 onboarding ramp", kpi: "90 day plan", progress: 78, approved: false },
          ],
          yearly: [
            { title: "Lead 6-eng sub-org", kpi: "Org chart sign-off", progress: 10, approved: false },
          ],
        },
      },
    },
  },
  learnings: {
    lessons: [
      { id: 1, source: "win", when: "Feb 12 · eKYC ship", title: "Architecture decisions compound when documented early", body: "RFC before code reduced alignment stalls.", applyTo: "Write RFC before sprint zero.", tag: "Process", endorsements: "3 endorsed" },
      { id: 2, source: "miss", when: "Mar 04 · NSCCL escalation", title: "Solo heroics burn second-priority work", body: "Escalation focus delayed strategic outputs.", applyTo: "Pair a primary owner on every escalation.", tag: "Self pattern", endorsements: "flagged x2" },
      { id: 3, source: "shift", when: "Mar 22 · clinic feedback", title: "Mentorship is leverage, not overhead", body: "Coaching unblocked more reviews than direct execution.", applyTo: "Group RFC clinics in Q2.", tag: "Leadership", endorsements: "5 endorsed" },
    ],
    themes: [
      { label: "Leverage over heroics", count: 4 },
      { label: "Write things down earlier", count: 3 },
      { label: "Schedule the strategic", count: 2 },
      { label: "Trust the second profile", count: 2 },
      { label: "Pair-share escalations", count: 1 },
    ],
    commits: [
      { text: "Block Tue/Thu strategic mornings", status: "done", meta: "Done · Apr 18" },
      { text: "Move RFC clinic to group format", status: "done", meta: "Done · Apr 20" },
      { text: "Pair Karan as primary on next escalation", status: "open", meta: "Open · ETA Apr 28" },
      { text: "Add trace-gate to perf PRs", status: "open", meta: "Open · ETA May 02" },
    ],
    quote: "A retro that doesn't change next quarter is just journaling.",
  },
  submitReflection: {
    reviewerName: "Priya",
    weeks: [
      { id: "w17", label: "Wk 17 · Apr 21–27", submitted: false },
      { id: "w16", label: "Wk 16 · Apr 14–20", submitted: false },
      { id: "w15", label: "Wk 15 · Apr 07–13", submitted: true },
      { id: "w14", label: "Wk 14 · Mar 31–Apr 06", submitted: true },
    ],
    promptDefs: [
      { key: "went_well", label: "What went well", maxChars: 600 },
      { key: "do_better", label: "What can be done better", maxChars: 600 },
      { key: "improve", label: "What I am going to improve", maxChars: 600 },
      { key: "repeat", label: "Where I'm going repeat", maxChars: 600 },
    ],
    visibilityOptions: [
      { value: "reviewer", label: "Reviewer" },
      { value: "skip_level", label: "Skip-level" },
      { value: "team", label: "Team" },
      { value: "private", label: "Private" },
    ],
  },
};
